import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Contexts
import { CurrencyProvider } from "./contexts/CurrencyContext";

// Components
import Header from "./components/Header";
import Hero from "./components/Hero";
import DestinationsPreview from "./components/DestinationsPreview";
import ServicesOverview from "./components/ServicesOverview";
import TravelTypes from "./components/TravelTypes";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";

// Pages
import DestinationsPage from "./pages/Destinations";
import ServicesPage from "./pages/Services";
import WhyTriptoPage from "./pages/WhyTripto";
import BlogPage from "./pages/Blog";
import ContactPage from "./pages/Contact";

const Home = () => {
  return (
    <>
      <Hero />
      <DestinationsPreview />
      <TravelTypes />
      <ServicesOverview />
      <Testimonials />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <CurrencyProvider>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/destinations" element={<DestinationsPage />} />
            <Route path="/destinations/:destinationId" element={<DestinationsPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/why-us" element={<WhyTriptoPage />} />
            <Route path="/about" element={<WhyTriptoPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:postId" element={<BlogPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </CurrencyProvider>
    </div>
  );
}

export default App;